import { useLang } from 'hooks/lang';

import { PropertyWithIcon } from 'components/PropertyWithIcon';
import { Row } from 'components/Blocks';
import { CircleDollarIcon } from 'components/Icons';

import { usePackage } from '../context';

import { formatCurrency } from 'utils/text';
import ChangePackageValue from './ChangeValue';

export function PackageValue(): JSX.Element {
  const { t } = useLang();

  const { data } = usePackage();

  return (
    <Row gap="2">
      <PropertyWithIcon
        icon={<CircleDollarIcon />}
        name={t('value')}
        value={formatCurrency(data?.value || '', data?.currency)}
      />

      <ChangePackageValue />
    </Row>
  );
}
